<template>
  <el-popover placement="bottom" width="180" v-model="show" trigger="hover">
    <div class="popover-container">
      <div class="date-text">{{ date }}</div>
      <div
        class="post-item common-post-item"
        :key="item.id"
        v-for="item in model.items"
        @click="itemClick(item)"
        :class="[{ story: item.mediaType === 3 }, item.state]"
      >
        <div class="post-image-container">
          <div
            v-lazy:background-image="item.coverUrl"
            :key="item.coverUrl"
            class="post-image"
          >
            <div class="mul-icon" v-show="item.mediaList.length > 1"></div>
            <div
              v-show="item.isVideo"
              style="width: 20px; height: 20px"
              class="video-icon"
            ></div>
            <div class="post-state-icon"></div>
          </div>
        </div>
        <div class="time-container">
          {{ item.postTimeStr }}
          <span v-if="item.deleteTimeStr">➞{{ item.deleteTimeStr }}</span>
        </div>
      </div>
    </div>
    <div v-show="model.items.length > 3" slot="reference">
      <div class="more-container">+{{ model.items.length - 3 }} More</div>
    </div>
  </el-popover>
</template>

<script>
import moment from "moment-timezone";

export default {
  name: "SchedulePostsMorePopoverComponent",
  data() {
    return {
      show: false,
    };
  },
  props: {
    // 所有post項
    model: {
      type: Object,
      required: true,
    },
  },
  methods: {
    itemClick(item) {
      this.show = false;
      this.$emit("itemClick", item);
    },
  },
  computed: {
    date() {
      return moment(this.model.date).format("ddd, MMM D");
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/style/theme.less";

.popover-container {
  text-align: right;
  margin: 15px;
  padding-left: 0;
  .date-text {
    text-align: left;
    margin-bottom: 14px;
    font-size: 14px;
  }
  .video-icon {
    width: 20px;
    height: 20px;
  }
  .post-item {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    cursor: pointer;
    &.story {
      .post-state-icon {
        right: -2px;
        bottom: -2px;
      }
    }
    .time-container {
      padding-left: 10px;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  .mul-icon {
    width: 13px !important;
    height: 13px !important;
  }
}

.more-container {
  font-size: 13px;
  color: @color-primary;
  cursor: pointer;
  display: flex;
  text-align: center;
}
</style>
